import Color from 'color';

const colorHsla = (color, s, l, a = 1) => {
  return Color(color)
    .saturationl(s)
    .lightness(l)
    .alpha(a)
    .string();
};

export const primary_dark15 = primary => {
  return Color(primary)
    .darken(0.15)
    .string();
};

export const primary_l50 = primary => {
  return Color(primary)
    .lightness(50)
    .string();
};

export const primary_light = primary => {
  return colorHsla(primary, 48, 92); //return colorHsla(primary, 48, 79);
};

export const primary_s5_l50 = primary => {
  return colorHsla(primary, 5, 50);
};

export const primary_s5_l55 = primary => {
  return colorHsla(primary, 5, 55);
};

export const primary_s5_l60 = primary => {
  return colorHsla(primary, 5, 60);
};

export const primary_s5_l70 = primary => {
  return colorHsla(primary, 5, 70);
};

export const primary_s5_l90 = primary => {
  return colorHsla(primary, 5, 90);
};

export const primary_s5_l96 = primary => {
  return colorHsla(primary, 5, 96);
};

export const primary_s10_l60 = primary => {
  return colorHsla(primary, 10, 60);
};

export const primary_s10_l75 = primary => {
  return colorHsla(primary, 10, 75);
};

export const primary_s10_l90 = primary => {
  return colorHsla(primary, 10, 90);
};

export const primary_s10_l96 = primary => {
  return colorHsla(primary, 10, 96);
};

export const primary_s15_l20 = primary => {
  return colorHsla(primary, 15, 20);
};

export const primary_s20_l87 = primary => {
  return colorHsla(primary, 20, 87);
};

export const primary_s20_l95 = primary => {
  return colorHsla(primary, 20, 95);
};

export const primary_s25_l90 = primary => {
  return colorHsla(primary, 25, 90);
};

export const primary_s26_l96 = primary => {
  return colorHsla(primary, 26, 96);
};

export const primary_s30_l50 = primary => {
  return colorHsla(primary, 30, 50);
};

export const primary_s30_l70 = primary => {
  return colorHsla(primary, 30, 70);
};

export const primary_s45_l96 = primary => {
  return colorHsla(primary, 45, 96);
};

export const primary_s98_l83 = primary => {
  return colorHsla(primary, 98, 83);
};

export const primary_s5_l70_a015 = primary => {
  return colorHsla(primary, 5, 70, 0.15);
};

export const primary_s20_l70_a015 = primary => {
  return colorHsla(primary, 20, 70, 0.15);
};

export const primary_s20_l70_a025 = primary => {
  return colorHsla(primary, 20, 70, 0.25);
};

export const primary_darken_5 = primary => {
  return Color(primary)
    .darken(0.05)
    .string();
};

export const primary_lighten_10 = primary => {
  return Color(primary)
    .lighten(0.1)
    .string();
};
